import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { roleTypes } from "./data/roleType";

//router
import { createBrowserRouter, RouterProvider } from "react-router-dom";
//store
import { Provider, useDispatch, useSelector } from "react-redux";
//reducer
import { store } from "./store";

// HOCs
import PublicRoute from "./components/public-route";
import { PublicRouter } from "./router/public-router";
// import { AdminRouter } from "./router/admin-router";
// import { SuperAdminRouter } from "./router/superadmin-router";
import ProtectedAdminRoute from "./components/protected-admin-route";
// import { CommonRouter } from "./router/common-router";
import * as SettingSelector from "./store/setting/selectors";
// import { CommonAdminRouter } from "./router/common-user-router";
// import { RoleRouter } from "./router/role-router";
// import { CommonGeneralRoleRouter } from "./router/common-outerrole-router";
// import { CommonWarehouseGeneralRoleRouter } from "./router/common-warehouse-general-router";
import { CommonRoutes } from "./router/common-router";

import { PublicTestRouter } from "./router/public-test-router";
import VisitorTracker from "./components/visitorTracker";

const withVisitorTracking = (Element) => (
  <>
    <VisitorTracker />
    {Element}
  </>
);
const AppRouter = () => {
  const dispatch = useDispatch();
  const roles = useSelector(SettingSelector.set_roles);
  const [roleLoaded, setRoleLoaded] = useState(false);
  useEffect(() => {
    // Wait until roles are fetched before rendering
    if (roles.length > 0) {
      setRoleLoaded(true);
    }
  }, [roles]);

  // Loading state until roles are available
  if (!roleLoaded) {
    return <div>Loading...</div>;
  }

  const router = createBrowserRouter(
    [
      ...CommonRoutes.map((route) => ({
        ...route,
        element: withVisitorTracking(
          <ProtectedAdminRoute
            allowedRoles={
              route.allowedRoles || [
                roleTypes.SUPER_ADMIN,
                roleTypes.ADMIN,
                roleTypes.WAREHOUSE,
                roleTypes.SUPPLIER,
                roleTypes.PURCHASING,
              ]
            }
            element={route.element}
          />
        ),
      })),

      ...PublicRouter.map((route) => ({
        ...route,
        element: withVisitorTracking(
          <PublicRoute element={route.element} restricted={true} />
        ),
      })),

      ...PublicTestRouter.map((route) => ({
        ...route,
        element: withVisitorTracking(route.element),
      })),
    ],
    { basename: process.env.PUBLIC_URL }
  );

  return <RouterProvider router={router} />;
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <App>
        <AppRouter />
      </App>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
